/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */

export default class OnboardingRoutes {
  static Default = ''
  static Root = '/'
  static FaceSplit = (s) => /\/face\/(?<zoom>.*?)\/(?<part>.*?)\//.exec(s)?.groups
  static Face = (zoom = ':zoom', part = '') => `/face/${zoom}/${part}`
  static Portrait = 'portrait'
  static Full = 'full'
  static Head = 'head'
  static Eyes = 'eyes'
  static NoseMouth = 'nose-mouth'
  static Hair = 'hair'
  static Body = 'body'
  static Name = () => '/name/'
  static Register = () => '/register/'
}
